import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入全局的配置数据(https://blog.csdn.net/xpf5211/article/details/119798429)
import config from './config/index.js'
Vue.use(config)

// 全局的事件总线
Vue.prototype.$EventBus = new Vue()

// 引入全局事件的名称
import * as eventType from './config/eventType.js'
Vue.prototype.$eventType = eventType

// 引入http请求
import * as http from './http/index.js'
Vue.prototype.$http = http

// 引入全局组件
import components from './components/index.js'
Object.keys(components).forEach(key => Vue.component(key, components[key]))

// 引入全局类型组件
import typeComponents from 'components/common/index.js'
Object.keys(typeComponents).forEach(key => Vue.component(key, typeComponents[key]))

// 引入全局插件
import plugs from './plug/index.js'
Object.keys(plugs).forEach(key => Vue.use(plugs[key]))

// 引入浏览器唯一标识
import uuid from './plug/uuid.js'
Vue.prototype.$uuid = uuid()

// 引入时间函数
import time from './plug/time.js'
Vue.prototype.$time = time

// 引入验证规则
import verify from './plug/verify.js'
Vue.prototype.$verify = verify

// 用户输入信息
import userInfo from './util/userInfo.js'
Vue.prototype.$userInfo = userInfo

// 引入联系弹窗
import contact from './components/contact/index.js'
Vue.use(contact)

// 用户登录注册弹窗
import getUserInfo from './components/getUserInfo/index.js'
Vue.use(getUserInfo)

// 打印(指令模式)
import Print from 'vue-print-nb'
Vue.use(Print)

// 引入自定义指令
import directive from './directive/index.js'
Object.keys(directive).forEach(key => Vue.directive(key, directive[key]))

// 禁止页面缩放
import './util/pageScaleDisabled.js'

// // 字体图标
// npm i --save @fortawesome/fontawesome-svg-core
// npm i --save @fortawesome/vue-fontawesome
// npm i --save @fortawesome/free-solid-svg-icons
// npm i --save @fortawesome/free-brands-svg-icons
// npm i --save @fortawesome/free-regular-svg-icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas, far, fab)

// <font-awesome-icon :icon="['fas', 'angle-left']" />
// <font-awesome-icon icon="angle-left" />
// <font-awesome-icon :icon="['fab', 'weixin']" />
Vue.component('font-awesome-icon', FontAwesomeIcon)

router.beforeEach((to, from, next) => {
	if (to.path === '/') {
        // ...
    }
	next();
})

Vue.config.productionTip = false

Vue.prototype.$config.extendConfig().then(_config => {
    // 实例化Vue
    new Vue({
    	router,
    	render: h => h(App)
    }).$mount('#app')
});

// new Vue({
//     router,
//     render: h => h(App)
// }).$mount('#app')
